module.exports = __webpack_public_path__ + "img/404.98ffcb90.png";